// Action creators for session storage


export const storeKeyValueInSessionStorage = (key, value) => ({
    type: key,
    payload: value,
});
export const storeKeyValueInLocalStore = (key, value) => ({
    type: key,
    payload: value,
});
